export default __webpack_public_path__ + "static/media/F0005.19a3744a.png";